module.exports = __webpack_public_path__ + "img/rotate.da099444.png";